import React from 'react';

const formatJoinedDate = (value) => {
  if (!value) {
    return null;
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  return date.toLocaleDateString(undefined, {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
};

const AboutUser = ({ user }) => {
  if (!user) {
    return <div>Loading user data...</div>;
  }

  const details = [
    { label: 'Full name', value: user.name },
    { label: 'Email address', value: user.email },
    { label: 'Handle', value: user.handle ? `@${user.handle}` : null },
    { label: 'Joined', value: formatJoinedDate(user.createdAt) },
  ].filter((detail) => Boolean(detail.value));

  return (
    <div className="about-user-container">
      <div className="about-user-header">
        <div className="about-user-avatar-shell">
          <img src={user.avatar?.url || '/DefaultAvatar.png'} alt="" className="about-user-avatar" />
        </div>
        <div>
          <p className="about-user-eyebrow">Profile</p>
          <h3 className="about-user-title">About {user.name}</h3>
          <p className="about-user-subtitle">Contact details and profile information.</p>
        </div>
      </div>
      <div className="about-user-content">
        {details.length > 0 ? (
          <dl className="about-user-details">
            {details.map((detail) => (
              <div className="about-user-row" key={detail.label}>
                <dt className="about-user-label">{detail.label}</dt>
                <dd className="about-user-value">{detail.value}</dd>
              </div>
            ))}
          </dl>
        ) : (
          <p className="about-user-subtitle">No profile details available.</p>
        )}
      </div>
    </div>
  );
};

export default AboutUser;

